export const MATRIX_PREFIX_LABEL = 'RQ';

/**
 * The API stores and returns a record prefix as "50.1"; the screens show it as "RQ50.1". Safe on a
 * value that already carries the label, so a row can pass through it twice.
 */
export function formatMatrixPrefix(prefix: string): string {
  const trimmed = prefix.trim();
  if (!trimmed) return '';
  return trimmed.toUpperCase().startsWith(MATRIX_PREFIX_LABEL)
    ? trimmed
    : `${MATRIX_PREFIX_LABEL}${trimmed}`;
}
